/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import PricingBanner from "./PricingBanner";
import RegulatoryCharges from "./RegulatoryCharges";
import DematCharges from "./DematCharges";
import GetStartedSection from "./GetStartedSection";
import PriceTable from "./PriceTable";
import OtherCharges from "./OtherCharges";
import BrokerageCharges from "./BrokerageCharges";

export {
  PricingBanner,
  RegulatoryCharges,
  DematCharges,
  GetStartedSection,
  PriceTable,
  OtherCharges,
  BrokerageCharges
};
